import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: {
    textAlign: 'center',
    margin: 5,
    padding: 10,
    backgroundColor: '#f9f9f9',
    borderRadius: 10,
  },
}));
